module.exports = __webpack_public_path__ + "static/media/availability-slide-3.bd874111.jpg";